/*
 * @Author: undefined undefined
 * @Date: 2022-09-30 14:41:49
 * @LastEditors: undefined undefined
 * @LastEditTime: 2022-09-30 16:09:52
 * @FilePath: \ant-v3-nancal\components\select\utils\iconUtil.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import CaretDownOutlined from '@nancal-icon/icons-vue/CaretDownOutlined';
import LoadingOutlined from '@nancal-icon/icons-vue/LoadingOutlined';
import CheckOutlined from '@nancal-icon/icons-vue/CheckOutlined';
import CloseOutlined from '@nancal-icon/icons-vue/CloseOutlined';
import CloseCircleFilled from '@nancal-icon/icons-vue/CloseCircleFilled';
import SearchOutlined from '@nancal-icon/icons-vue/SearchOutlined';
export default function getIcons(props, slots = {}) {
    const { loading, multiple, prefixCls } = props;
    const suffixIcon = props.suffixIcon || (slots.suffixIcon && slots.suffixIcon());
    const clearIcon = props.clearIcon || (slots.clearIcon && slots.clearIcon());
    const menuItemSelectedIcon = props.menuItemSelectedIcon || (slots.menuItemSelectedIcon && slots.menuItemSelectedIcon());
    const removeIcon = props.removeIcon || (slots.removeIcon && slots.removeIcon());
    // Clear Icon
    let mergedClearIcon = clearIcon;
    if (!clearIcon) {
        mergedClearIcon = <CloseCircleFilled />;
    }
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) {
        mergedSuffixIcon = suffixIcon;
    }
    else if (loading) {
        mergedSuffixIcon = <LoadingOutlined spin/>;
    }
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = ({ open, showSearch }) => {
            if (open && showSearch) {
                return <SearchOutlined class={iconCls}/>;
            }
            return <CaretDownOutlined class={iconCls}/>;
        };
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) {
        mergedItemIcon = menuItemSelectedIcon;
    }
    else if (multiple) {
        mergedItemIcon = <CheckOutlined />;
    }
    else {
        mergedItemIcon = null;
    }
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) {
        mergedRemoveIcon = removeIcon;
    }
    else {
        mergedRemoveIcon = <CloseOutlined />;
    }
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon,
    };
}
